import { TFunction } from "i18next";
import * as Yup from "yup";

export const scheduleAccessSchema = (t: TFunction) =>
  Yup.object({
    link: Yup.string().url(t("profile.Url is not valid")),
  });
